import Vue from 'vue'
import Router from 'vue-router'
const DefaultContainer = () => import('../containers/DefaultContainer');
const SystemContainer = () => import('../containers/SystemContainer');
const Dashboard = () => import('@/views/Dashboard')
const Login = () => import('@/views/Login')
import { List, Create, UserUpdateForm, UserGroupList, UserGroupForm,
    ChangePassword, UserSetting, UserProfile } from '@/views/Users';
import { 
    PositionList,
    EmployeeList, EmployeeCreate,
    Payroll, PayrollPreview,
    Allowance, MonthlyAllowance,
    DisciplineList, DisciplineForm
 } from '@/views/Employees';
import { BranchList, BranchForm } from '@/views/Branch';
const CategoryList = () => import('@/views/Categories/List');
const CompanyList = () => import('@/views/Company/List');
import { ItemList, ItemForm } from '@/views/Item';
const UomList = () => import('@/views/UOM/List');
const BrandList = () => import('@/views/Brands/List');
const ImageList = () => import('@/views/Image/List');
import { Expanse, ExpenseForm, ExpensePreviewForm } from '@/views/Expenses';
import {
    AccountType, ChartOfAccount, ChartOfAccountForm,
    GeneralJournal,
    GeneralJournalForm,
    ChartOfAccountImport,
    GeneralJournalImport,
    GeneralLedger,
    ProfitAndLost,
    BalanceSheet,
    CashFlow,
    IncomeStatement,
    TrialBalance,
    CostItemHistory
} from '@/views/Accountings';
import {
    LeaveTypeList, LeaveTypeForm,
    LeaveSchemeList, LeaveSchemeForm,
    LeaveApplyScheme, LeaveBalance,
    LeaveApplicationList, LeaveApplicationForm, LeaveApplicationPreview
} from '@/views/Leaves';
const Income = () => import('@/views/Incomes/List');
const IncomeForm = () => import('@/views/Incomes/Form');
const IncomeImport = () => import('@/views/Incomes/Import');
const LocationList = () => import('@/views/Location/Location');
const LocationForm = () => import('@/views/Location/LocationForm');
const RemindAR = () => import('@/views/RemindAR/RemindAR');
const RemindARForm = () => import('@/views/RemindAR/RemindARForm');
const RemindAP = () => import('@/views/RemindAP/RemindAP');
const RemindAPForm = () => import('@/views/RemindAP/RemindAPForm');
const BarcodeForm = () => import('@/views/Barcode/BarcodeForm');
const Barcode = () => import('@/views/Barcode/Barcode');
import{ HolidayForm, HolidayList } from '@/views/PublicHoliday';
import { CustomerList, CustomerForm, CustomerTypeList, CustomerTypeForm } from '@/views/Customer';
import { VendorList, VendorForm } from '@/views/Vendors';
import {
        SaleInvoiceList, SaleInvoiceForm, SaleInvoicePreview, SaleInvoiceFromDelivery, SaleInvoiceToStockout,
        SaleQuoteList, SaleQuoteForm, SaleQuotePreview, PrintSaleQuote,
        SaleOrderList, SaleOrderForm, SaleOrderPreview, SaleOrderToInvoice, SaleOrderToStockout,
        SaleExchangeList, SaleExchangeForm, SaleExchangePreview,
        PrintSaleInvoice, PrintSaleOrder,
        SaleReceiptList, SaleReceiptFromInvoice, SaleReceiptPreview,
        SaleDeliveryList, SaleDeliveryForm, SaleInvalidCalculation
} from '@/views/Sales';
import {
        PurchaseOrderList, PurchaseOrderForm, PurchaseOrderPreview, PurchaseOrderToInvoice, PurchaseOrderToStock,
        PurchaseInvoiceList, PurchaseInvoiceForm,
        PurchaseExchange, PurchaseExchangeForm, PurchaseExchangePreview,
        PurchaseInvoicePreview, PrintPurchaseInvoice,
        PurchaseReceiptList, PurchaseReceiptForm, PurchaseReceiptFromInvoice, PurchaseReceiptPreview,
        PurchaseStockInForm
} from '@/views/Purchases';
import {
        StockOnHandList, StockOnHandForm,
        StockInList, StockInPreview,
        StockInForm, StockOutList,
        StockOutForm, StockOutPreview,
        StockDamageList, StockDamageForm, StockDamagePreview,
        AdjustStockList, AdjustStockForm, StockAdjustPreview,
        StockTransferList, StockTransferForm, StockTransferPreview,
        StockConversionList, StockConversionForm,
        PackageList, PackageForm, PackagePreview, PackageToStock
} from '@/views/Stocks';
import moment from 'moment';
import { i18n } from '@/plugins/i18n';
import {
        ReportDashboard, TaxSalary, ReportPriceList,
        ReportStockInOut,ReportStockIn,
        ReportStockOut,ReportStockOnHand,
        PrintStockIn, PrintStockInDetail, PrintStockOutDetail, PrintStockOut,
        PrintReportPriceList, PrintStockInOut, PrintStockOnHand, PrintExchange, PrintStockDamage,
        PrintPurchasesExchange, PrintStockAdjust, PrintStockTransfer, PrintTaxInvoice,
        PrintNonTaxInvoice, ReportARPreview, PrintARPreview, ReportAccountPayment, PrintAccountPayment,
        ReportOutOfStock, PrintOutOfStock, ReportStockSummary, ReportExpenseSummary,
        ReportSaleDashboard, ReportPurchaseDashboard, ReportIncomeStatement,
        PrintSaleSummary, PrintSaleOperation, PrintSaleDetail, PrintSaleMonthly, PrintSaleYearly,
        PrintPOSummarySection, PrintPOOperationSection, PrintPODetailSection, PrintPOMonthlySection, PrintPOYearlySection,
        PrintExpenseSummarySection, PrintExpenseOperationSection, PrintExpenseReturnSection, PrintExpenseCostSection, PrintExpenseMonthlySection, PrintExpenseYearlySection,
} from '../views/Reports'
import * as Settings from '../views/Settings';
import * as Systems from "../views/Systems";


Vue.use(Router)
const excepts = ['login'];
const router = new Router({
    mode: 'history',
    routes: [
        { path: '/print/sale/quote/:id', component: PrintSaleQuote, meta: { title: i18n.t('sale_quotation') } },
        { path: '/print/sale/order/:id', component: PrintSaleOrder, meta: { title: i18n.t('sale_order') } },
        { path: '/print/sale/:id', component: PrintSaleInvoice, meta: { title: i18n.t('invoice') } },
        { path: '/print/purchase/:id', component: PrintPurchaseInvoice, meta: { title: i18n.t('purchase_invoice') } },
        { path: '/print/price/list', component: PrintReportPriceList, meta: { title: i18n.t('report_price_list') } },
        { path: '/print/stock/inout', component: PrintStockInOut, meta: { title: i18n.t('report_price_list') } },
        { path: '/print/stock/onhand', component: PrintStockOnHand, meta: { title: i18n.t('stock_on_hand_list') } },
        { path: '/print/stockin/:id', component: PrintStockIn, meta: { title: i18n.t('stock_in') } },
        { path: '/print/detail/stockin', component: PrintStockInDetail, meta: { title: i18n.t('stock_in_detail') } },
        { path: '/print/detail/stockout', component: PrintStockOutDetail, meta: { title: i18n.t('stock_out_detail') } },
        { path: '/print/stockout/:id', component: PrintStockOut, meta: { title: i18n.t('stock_out') } },
        { path: '/print/exchange/:id', component: PrintExchange, meta: { title: 'Exchange' } },
        { path: '/print/stockDamage/:id', component: PrintStockDamage, meta: { title: 'StockDamage' } },
        { path: '/print/purchasesExchange/:id', component: PrintPurchasesExchange, meta: { title: 'PurchasesExchange' } },
        { path: '/print/stockAdjust/:id', component: PrintStockAdjust, meta: { title: 'StockAdjust' } },
        { path: '/print/stockTransfer/:id', component: PrintStockTransfer, meta: { title: 'StockTransfer' } },
        { path: '/print/taxInvoice/:id', component: PrintTaxInvoice, meta: { title: 'TaxInvoice' } },
        { path: '/print/nonTaxInvoice/:id', component: PrintNonTaxInvoice, meta: { title: 'NonTaxInvoice' } },
        { path: '/print/ARPreview', component: PrintARPreview, meta: { title: i18n.t('report_customer_loan') } },
        { path: '/print/accountpayment', component: PrintAccountPayment, meta: { title: i18n.t('report_account_payment') } },
        { path: '/print/outofstock', component: PrintOutOfStock, meta: { title: i18n.t('report_out_of_stock') } },    
        { path: '/print-sale-summary', component: PrintSaleSummary, meta: { title: i18n.t('sale_summary') } },
        { path: '/print-sale-operation', component: PrintSaleOperation, meta: { title: i18n.t('sale_operation') } },
        { path: '/print-sale-detail', component: PrintSaleDetail, meta: { title: i18n.t('sale_operation_detail') } },
        { path: '/print-sale-monthly', component: PrintSaleMonthly, meta: { title: i18n.t('sale_operation_monthly') } },
        { path: '/print-sale-yearly', component: PrintSaleYearly, meta: { title: i18n.t('sale_operation_yearly') } },
        { path: '/print-purchase-summary', component: PrintPOSummarySection, meta: { title: i18n.t('purchase_summary') } },
        { path: '/print-purchase-operation', component: PrintPOOperationSection, meta: { title: i18n.t('purchase_operation') } },
        { path: '/print-purchase-detail', component: PrintPODetailSection, meta: { title: i18n.t('purchase_operation_detail') } },
        { path: '/print-purchase-monthly', component: PrintPOMonthlySection, meta: { title: i18n.t('purchase_operation_monthly') } },
        { path: '/print-purchase-yearly', component: PrintPOYearlySection, meta: { title: i18n.t('purchase_operation_yearly') } },
        { path: '/print-expense-summary', component: PrintExpenseSummarySection, meta: { title: i18n.t('expense_summary') } },
        { path: '/print-expense-cost', component: PrintExpenseCostSection, meta: { title: i18n.t('expense_on_cost') } },
        { path: '/print-expense-operation', component: PrintExpenseOperationSection, meta: { title: i18n.t('expense_on_operation') } },
        { path: '/print-expense-return', component: PrintExpenseReturnSection, meta: { title: i18n.t('expense_on_sale_return') } },
        { path: '/print-expense-monthly', component: PrintExpenseMonthlySection, meta: { title: i18n.t('expense_monthly') } },
        { path: '/print-expense-yearly', component: PrintExpenseYearlySection, meta: { title: i18n.t('expense_yearly') } },
        {
            path: '/', component: DefaultContainer,
            children: [
                { path: '/', component: Dashboard, meta: { title: 'Dashboard' }},
                { path: '/user', name: 'user', component: List, meta:{ title: i18n.t('user_list') }},
                { path: '/user/create', component: Create, meta: { title: i18n.t('user_create') }},
                { path: '/user/edit/:id', name: 'user_edit', component: UserUpdateForm, meta: { title: i18n.t('user_update') }},
                { path: '/branch', name: 'branch', component : BranchList, meta: { title: i18n.t('branch_list') }},
                { path: '/branch/create', name: 'branch_create', component: BranchForm, meta: { title: i18n.t('branch_create') }},
                { path: '/branch/edit/:id', name: 'branch_edit', component: BranchForm, meta: { title: i18n.t('branch_edit') }},
                { path: '/category', name: 'category', component: CategoryList, meta: { title: i18n.t('item_category_list') }},
                { path: '/company', name: 'company', component: CompanyList, meta: { title: i18n.t('company_info') }},
                { path: '/item', name: 'item', component: ItemList, meta: { title: i18n.t('item_list') }},
                { path: '/item/create', name: 'item_create', component: ItemForm, meta: { title: i18n.t('create_new_item') }},
                { path: '/item/edit/:id', name: 'item_edit', component: ItemForm, meta: { title: 'Update item info' }},
                { path: '/uom', name: 'uom', component: UomList, meta: { title: i18n.t('uom_list') }},
                { path: '/brands', component: BrandList, meta: { title: i18n.t('brand_list') }},
                { path: '/image', name: 'image', component: ImageList },
                { path: '/accounting/types', component: AccountType, meta: { title: i18n.t('account_type') }},
                { path: '/accounting/accounts', component: ChartOfAccount, meta: { title: i18n.t('chart_of_account') }},
                { path: '/accounting/account/:id', name: 'chart_of_account_update' ,component: ChartOfAccountForm, meta: { title: i18n.t('chart_of_account_update') }},
                { path: '/accounting/import/account', name: 'chart_of_account_import' ,component: ChartOfAccountImport, meta: { title: i18n.t('chart_of_account_import') }},
                { path: '/accounting/account', component: ChartOfAccountForm, meta: { title: i18n.t('chart_of_account_create') }},
                { path: '/accounting/journals', component: GeneralJournal, meta: { title: i18n.t('general_journal') }},
                { path: '/accounting/import/journal', name: 'account_journal_import', component: GeneralJournalImport, meta: { title: i18n.t('account_journal_import') }},
                { path: '/accounting/journal/:id', name: 'update_journal', component: GeneralJournalForm, meta: { title: i18n.t('account_journal_update') }},
                { path: '/accounting/journal', component: GeneralJournalForm, meta: { title: i18n.t('account_journal_create') }},
                { path: '/accounting/ledgers', component: GeneralLedger, meta: { title: i18n.t('account_ledger') }},
                { path: '/accounting/trialbalance', component: TrialBalance, meta: { title: i18n.t('account_trial_balance') }},
                { path: '/accounting/profitlosts', component: ProfitAndLost, meta: { title: i18n.t('account_profit_lost') }},
                { path: '/accounting/cashflows', component: CashFlow, meta: { title: i18n.t('account_cash_flow') }},
                { path: '/accounting/income/statements', component: IncomeStatement, meta: { title: i18n.t('account_income_statement') }},
                { path: '/accounting/balancesheets', component: BalanceSheet, meta: { title: i18n.t('account_balance_sheet') }},
                { path: '/expenses', component: Expanse, meta: { title: i18n.t('expense_list') }},
                { path: '/expense', component: ExpenseForm, meta: { title: i18n.t('expense_create') }},
                { path: '/expense/:id', name: 'expense_edit', component: ExpenseForm, meta: { title: i18n.t('expense_update') }},
                { path: '/preview/expense/:id', name: 'expense_preview', component: ExpensePreviewForm, meta: { title: i18n.t('expense_preview') }},
                { path: '/incomes', component: Income, meta: { title: i18n.t('income_list') }},
                { path: '/income', component: IncomeForm, meta: { title: i18n.t('income_create') }},
                { path: '/income/:id', name: 'income_edit', component: IncomeForm, meta: { title: i18n.t('income_update') }},
                { path: '/sale/invoices', component: SaleInvoiceList, meta: { title: i18n.t('sale_invoice') }},
                { path: '/sale/delivery/invoice', component: SaleInvoiceFromDelivery, meta: { title: i18n.t('sale_invoice_create') }},
                { path: '/sale/stockout/invoice/:id', component: SaleInvoiceToStockout, name: 'sale_invoice_to_stockout', meta: { title: i18n.t('stock_out') }},
                { path: '/sale/invoice', component: SaleInvoiceForm, meta: { title: i18n.t('sale_invoice_create') }},
                { path: '/sale/invoice/:id', name: 'sale_invoice_update', component: SaleInvoiceForm, meta: { title: i18n.t('sale_invoice_update') }},
                { path: '/sale/deliveries', component: SaleDeliveryList, meta: { title: i18n.t('sale_deliveries_list') }},
                { path: '/sale/delivery', component: SaleDeliveryForm, meta: { title: i18n.t('sale_delivery_form') }},
                { path: '/sale/view/:id', name: 'sale_invoice_view', component: SaleInvoicePreview, meta: { title: i18n.t('sale_invoice') }},
                { path: '/sale/quotes', component: SaleQuoteList, meta: { title: i18n.t('sale_quote_list') }},
                { path: 'sale/quote', component: SaleQuoteForm, meta: { title: i18n.t('sale_quote_create') }},
                { path: 'sale/quote/preview/:id', name: 'sale_quote_preview', component: SaleQuotePreview, meta: { title: i18n.t('sale_quote_preview') }},
                { path: 'sale/quote/:id', name: 'sale_quote_update', component: SaleQuoteForm, meta: { title: i18n.t('sale_quote_update') }},
                { path: 'sale/orders', component: SaleOrderList, meta: { title: i18n.t('sale_order_list') }},
                { path: 'sale/order', component: SaleOrderForm, meta: { title: i18n.t('sale_order_create') }},
                { path: 'sale/order/invoice/:id', name: 'sale_order_invoice_create', component: SaleOrderToInvoice, meta: { title: i18n.t('sale_order_invoice_create') }},
                { path: 'sale/order/:id', name: 'sale_order_update', component: SaleOrderForm, meta: { title: i18n.t('sale_order_update') }},
                { path: 'sale/preview/order/:id', name: 'sale_order_preview', component: SaleOrderPreview, meta: { title: i18n.t('sale_order_preview') }},
                { path: 'sale/exchanges', component: SaleExchangeList, meta: { title: i18n.t('sale_exchange_list') }},
                { path: 'sale/exchange', component: SaleExchangeForm, meta: { title: i18n.t('sale_exchange_create') }},
                { path: 'sale/exchange/preview:id',name: 'sale_exchange_preview', component: SaleExchangePreview, meta: { title: i18n.t('sale_exchange_preview') }},
                { path: 'sale/exchange/edit/:id', name: 'sale_exchange_update', component: SaleExchangeForm, meta: { title: i18n.t('sale_exchange_update') }},
                { path: 'sale/receipts', component: SaleReceiptList, meta: { title: i18n.t('sale_receipt_list') }},
                { path: 'sale/receipt/preview/:id', name: 'sale_receipt_preview', component: SaleReceiptPreview, meta: { title: i18n.t('sale_receipt_preview') }},
                { path: 'sale/frominvoice/:id', name: 'sale_invoice_receipt_create', component: SaleReceiptFromInvoice, meta: { title: i18n.t('sale_invoice_receipt_create') }},
                { path: '/sale/stockout/fromorder/:id', name: 'sale_stockout_create', component: SaleOrderToStockout, meta: { title: i18n.t('stockout_create') }},
                { path: '/sale/invalid-calculations', component: SaleInvalidCalculation },
                { path: 'purchase/orders', component: PurchaseOrderList, meta: { title: i18n.t('purchase_order_list') }},
                { path: 'purchase/order', component: PurchaseOrderForm, meta: { title: i18n.t('purchase_order_create') }},
                { path: 'purchase/order/invoice/:id', name: 'purchase_order_invoice_create', component: PurchaseOrderToInvoice, meta: { title: i18n.t('purchase_order_invoice_create') }},
                { path: 'purchase/order/stock/:id', name: 'purchase_order_stock', component: PurchaseOrderToStock, meta: { title: i18n.t('request_stock_in') }},
                { path: 'purchase/order/:id', name: 'purchase_order_update', component: PurchaseOrderForm, meta: { title: i18n.t('purchase_order_update') }},
                { path: 'purchase/order/preview/:id', name: 'purchase_order_preview', component: PurchaseOrderPreview, meta: { title: i18n.t('purchase_order_preview') }},
                { path: 'po/invoices', component: PurchaseInvoiceList, meta: { title: i18n.t('purchase_invoice')}},
                { path: 'po/invoice', component: PurchaseInvoiceForm, meta: { title: i18n.t('purchase_invoice_create') }},
                { path: 'po/invoice/:id', name: 'po_invoice_update', component: PurchaseInvoiceForm, meta: { title: i18n.t('purchase_invoice_update') }},
                { path: 'po/invoice/preview/:id', name: 'po_invoice_view', component: PurchaseInvoicePreview, meta: { title: i18n.t('purchase_invoice') }},
                { path: 'po/exchanges', component: PurchaseExchange, meta: { title: i18n.t('purchase_exchange') }},
                { path: 'po/exchange/preview/:id', component: PurchaseExchangePreview, name: 'purchase_exchange_preview', meta: { title: i18n.t('purchase_exchange_preview') }},
                { path: 'po/exchange', component: PurchaseExchangeForm, meta: { title: i18n.t('purchase_exchange_create') }},
                { path: 'po/exchange/:id', component: PurchaseExchangeForm, name: 'purchase_exchange_update', meta: { title: i18n.t('purchase_exchange_update') }},
                { path: 'po/receipts', component: PurchaseReceiptList, meta: { title: i18n.t('purchase_receipt_list') }},
                { path: 'po/invoice/receipt/:id', component: PurchaseReceiptFromInvoice, name: 'purchase_receipt_create', meta: { title: i18n.t('purchase_receipt_create') }},
                { path: 'po/receipt/:id', component: PurchaseReceiptForm, name: 'purchase_receipt_update', meta: { title: i18n.t('purchase_receipt_update') }},
                { path: 'po/preview/receipt/:id', component: PurchaseReceiptPreview, name: 'purchase_receipt_preview', meta: { title: i18n.t('purchase_receipt_preview') }},
                { path: 'po/stockin/:id', component: PurchaseStockInForm, name: 'purchase_stockin_create', meta: { title: i18n.t('purchase_stockin_create') }},
                {
                    path: '/customer',
                    name:'customer',
                    component: CustomerList,
                    meta: {
                        title: i18n.t('customer_list')
                    }
                },
                {
                    path: '/customer/create',
                    name: 'customer_create',
                    component: CustomerForm,
                    meta: {
                        title: i18n.t('customer_create')
                    }
                },
                {
                    path: '/customer/edit/:id',
                    name: 'customer_edit',
                    component: CustomerForm,
                    meta: {
                        title: i18n.t('customer_update')
                    }
                },
                {
                    path: '/customer/types',
                    name: 'customer_type',
                    component: CustomerTypeList,
                    meta: {
                        title: i18n.t('customer_type')
                    }
                },
                {
                    path: '/customer/type/create',
                    name: 'customer_type_create',
                    component: CustomerTypeForm,
                    meta: {
                        title: i18n.t('customer_type_create')
                    }
                },
                {
                    path: '/customer/type/edit/:id',
                    name: 'customer_type_update',
                    component: CustomerTypeForm,
                    meta: {
                        title: i18n.t('customer_type_update')
                    }
                },
                {
                    path: '/vendor',
                    component: VendorList,
                    meta: {
                        title: i18n.t('vendor_list')
                    }
                },
                {
                    path: '/vendor/create',
                    component: VendorForm,
                    meta: {
                        title: i18n.t('vendor_create')
                    }
                },
                {
                    path: '/vendor/edit/:id',
                    name: 'vendor_update',
                    component: VendorForm,
                    meta: {
                        title: i18n.t('vendor_create')
                    }
                },
                { path: '/onhands', component: StockOnHandList, meta: { title: i18n.t('stock_on_hand_list') }},
                { path: '/onhand', component: StockOnHandForm, meta: { title: i18n.t('stock_on_hand_create') }},
                {
                    path: '/stockin',
                    component: StockInList,
                    meta: {
                        title: i18n.t('stock_in_list')
                    }
                },
                {
                    path: '/stockin/create',
                    component: StockInForm,
                    meta: {
                        title: i18n.t('stock_in_create')
                    }
                },
                {
                    path: '/stockin/edit/:id',
                    name: 'stock_in_update',
                    component: StockInForm,
                    meta: {
                        title: i18n.t('stock_in_update')
                    }
                },
                {
                    path: '/stockin/view/:id',
                    name: 'stock_in_preview',
                    component: StockInPreview,
                    meta: {
                        title: i18n.t('stock_in_view')
                    }
                },
                {
                    path: '/stockout',
                    component: StockOutList,
                    meta: {
                        title: i18n.t('stock_out_list')
                    }
                },
                {
                    path: '/stockout/create',
                    component: StockOutForm,
                    meta: {
                        title: i18n.t('stock_out_create')
                    }
                },
                {
                    path: '/stockout/edit/:id',
                    name: 'stock_out_update',
                    component: StockOutForm,
                    meta: {
                        title: i18n.t('stock_out_create')
                    }
                },
                {
                    path: '/stockout/view/:id',
                    name: 'stock_out_preview',
                    component: StockOutPreview,
                    meta: {
                        title: i18n.t('stock_in_create')
                    }
                },
                {
                    path: 'reports',
                    component: ReportDashboard,
                    meta: {
                        title: i18n.t('reports')
                    }
                },
                {
                    path: '/employees',
                    component: EmployeeList,
                    meta: {
                        title: i18n.t('employee_list')
                    }
                },
                {
                    path: '/employee',
                    component: EmployeeCreate,
                    meta: {
                        title: i18n.t('employee_create')
                    }
                },
                {
                    path: '/employee/:id',
                    name: 'employee_update',
                    component: EmployeeCreate,
                    meta: {
                        title: i18n.t('employee_update')
                    }
                },
                {
                    path: '/tax/salary',
                    component: TaxSalary,
                    meta: {
                        title: i18n.t('tax_salary')
                    }
                },
                {
                    path: '/report/price/list',
                    component: ReportPriceList,
                    meta: {
                        title: i18n.t('report_price_list')
                    }
                },
                {
                    path: '/groups',
                    component: UserGroupList,
                    meta: {
                        title: i18n.t('user_group')
                    }
                },
                {
                    path: '/group',
                    component: UserGroupForm,
                    meta: {
                        title: i18n.t('user_group_create')
                    }
                },
                {
                    path: '/group/:id',
                    component: UserGroupForm,
                    name: 'user_group_update',
                    meta: {
                        title: i18n.t('user_group_update')
                    }
                },
                {
                    path: '/exchangerates',
                    component: Settings.ExchangeRate,
                    name: 'exchange_rate',
                    meta: {
                        title: i18n.t('exchange_rate')
                    }
                },
                {
                    path: '/exchangerate',
                    component: Settings.ExchangeRateForm,
                    name: 'exchange_rate_create',
                    meta: {
                        title: i18n.t('exchange_rate_create')
                    }
                },
                {
                    path: '/exchangerate/:id',
                    component: Settings.ExchangeRateForm,
                    name: 'exchange_rate_update',
                    meta: { title: i18n.t('exchange_rate_update') }
                },
                {
                    path: '/location/list',
                    component: LocationList,
                    name: 'location_list',
                    meta: { title: i18n.t('location_list') }
                },
                {
                    path: '/location',
                    component: LocationForm,
                    name: 'location_create',
                    meta: { title: i18n.t('location_create') }
                },
                {
                    path: '/remindap/list',
                    component: RemindAP,
                    name: 'remind_ap_list',
                    meta: { title: i18n.t('remind_ap_list') }
                },
                {
                    path: '/remindap',
                    component: RemindAPForm,
                    name: 'remind_ap_create',
                    meta: { title: i18n.t('remind_ar_create') }
                },
                {
                    path: '/remindar',
                    component: RemindARForm,
                    name: 'remind_ar_create',
                    meta: { title: i18n.t('remind_ar_create') }
                },
                {
                    path: '/remindar/list',
                    component: RemindAR,
                    name: 'remind_ar_list',
                    meta: { title: i18n.t('remind_ar_list') }
                },
                {
                    path: '/holiday',
                    component: HolidayList,
                    name: 'holiday_list',
                    meta: { title: i18n.t('holiday_list') }
                },
                {
                    path: '/holiday/create',
                    component: HolidayForm,
                    name: 'holiday_create',
                    meta: { title: i18n.t('holiday_create') }
                },
                {
                    path: '/holiday/:id',
                    component: HolidayForm,
                    name: 'holiday_update',
                    meta: { title: i18n.t('holiday_update') }
                },
                { path: '/barcode', component: BarcodeForm, name: 'barcode_create', meta: { title: i18n.t('barcode_create') }},
                { path: '/barcode/list', component: Barcode, name: 'barcode_list', meta: { title: i18n.t('barcode_list') }},
                { path: '/import/income', component: IncomeImport },
                { path: '/report/stock/onhand', component: ReportStockOnHand, meta: { title: i18n.t('stock_on_hand_list') } },
                { path: '/report/stock/inout', component: ReportStockInOut, meta: { title: i18n.t('invoice') } },
                { path: '/report/stockin', component: ReportStockIn, meta: { title: i18n.t('invoice') } },
                { path: '/report/stockout', component: ReportStockOut, meta: { title: i18n.t('invoice') } },
                { path: '/report/ARPreview', component: ReportARPreview, meta: { title: i18n.t('report_customer_loan') } },
                { path: '/report/accountpayment', component: ReportAccountPayment, meta: { title: i18n.t('report_account_payment') } },
                { path: '/report/outofstock', component: ReportOutOfStock, meta: { title: i18n.t('report_out_of_stock') } },
                { path: '/report/stock/summary/:id', component: ReportStockSummary, name: 'report_stock_summary', meta: { title: i18n.t('report_stock_summary') } },
                { path: '/report/expense/summaries', component: ReportExpenseSummary, name: 'report_expense_summary', meta: { title: i18n.t('report_expense_summary') } },
                { path: '/report/sale/dashboard', component: ReportSaleDashboard, name: 'report_sale_dashboard', meta: { title: i18n.t('report_sale_dashboard') } },
                { path: '/report/purchase/dashboard', component: ReportPurchaseDashboard, name: 'report_purchase_dashboard', meta: { title: i18n.t('report_purchase_dashboard') } },
                { path: '/report/income-statement', component: ReportIncomeStatement, meta: { title: i18n.t('income_statement') } },
                { path: '/stock/adjusts', component: AdjustStockList, meta: { title: i18n.t('stock_adjust_list') } },
                { path: '/stock/adjust', component: AdjustStockForm, meta: { title: i18n.t('stock_adjust_create') } },
                { path: '/stock/adjust/:id', component: AdjustStockForm, name: 'stock_adjust_update', meta: { title: i18n.t('stock_adjust_update') } },
                { path: '/stock/preview/adjust/:id', component: StockAdjustPreview, name: 'stock_adjust_preview', meta: { title: i18n.t('stock_adjust_preview') } },
                { path: '/stock/damages', component: StockDamageList, meta: { title: i18n.t('stock_damage_list') } },
                { path: '/stock/damage', component: StockDamageForm, meta: { title: i18n.t('stock_damage_create') } },
                { path: '/stock/damage/:id', component: StockDamageForm, name: 'stock_damage_update', meta: { title: i18n.t('stock_damage_update') } },
                { path: '/stock/preview/damage/:id', component: StockDamagePreview, name: 'stock_damage_preview', meta: { title: i18n.t('stock_damage_preview') } },
                { path: '/stock/transfers', component: StockTransferList, meta: { title: i18n.t('stock_transfer') } },
                { path: '/stock/transfer', component: StockTransferForm, meta: { title: i18n.t('stock_transfer_create') } },
                { path: '/stock/transfer/:id', component: StockTransferForm, name: 'stock_transfer_update', meta: { title: i18n.t('stock_transfer_update') } },
                { path: '/stock/preview/transfer/:id', component: StockTransferPreview, name: 'stock_transfer_preview', meta: { title: i18n.t('stock_transfer_preview') } },
                { path: '/stock/conversions', component: StockConversionList, meta: { title: i18n.t('stock_conversion') } },
                { path: '/stock/conversion', component: StockConversionForm, meta: { title: i18n.t('stock_conversion_create') } },
                { path: '/stock/conversion/:id', component: StockConversionForm, name: 'stock_conversion_update', meta: { title: i18n.t('stock_conversion_update') } },
                { path: '/cost/hostory/:id', component: CostItemHistory, name: 'cost_item_history', meta: { title: i18n.t('cost_item_histories') }},
                { path: '/leaves', component: LeaveTypeList, meta: {title: i18n.t('leave_category')}},
                { path: '/leave', component: LeaveTypeForm, meta: {title: i18n.t('leave_type_create')}},
                { path: '/leave/:id', component: LeaveTypeForm, name: 'leave_type_update', meta: {title: i18n.t('leave_type_update')}},
                { path: '/schemes', component: LeaveSchemeList, meta: {title: i18n.t('leave_scheme')}},
                { path: '/scheme', component: LeaveSchemeForm, meta: {title: i18n.t('leave_scheme_create')}},
                { path: '/scheme/:id', component: LeaveSchemeForm, name: 'leave_scheme_update', meta: {title: i18n.t('leave_scheme_update')}},
                { path: '/apply/schemes', component: LeaveApplyScheme, meta: { title: i18n.t('leave_apply_scheme') }},
                { path: '/balance/:id', component: LeaveBalance, name: 'leave_balance', meta: { title: i18n.t('leave_balance') }},
                { path: '/applications', component: LeaveApplicationList, meta: { title: i18n.t('leave_application') }},
                { path: '/application/create', component: LeaveApplicationForm, meta: { title: i18n.t('leave_application_create') }},
                { path: '/application/preview/:id', component: LeaveApplicationPreview, name: 'leave_application_preview', meta: { title: i18n.t('leave_application_preview') }},
                { path: '/application/edit/:id', component: LeaveApplicationForm, name: 'leave_application_update', meta: { title: i18n.t('leave_application_update') }},
                { path: '/packages', component: PackageList, meta: { title: i18n.t('packaging') }},
                { path: '/package', component: PackageForm, meta: { title: i18n.t('packaging_create') }},
                { path: '/package/:id', component: PackageForm, name: 'packaging_update', meta: { title: i18n.t('packaging_update') }},
                { path: '/package/preview/:id', component: PackagePreview, name: 'packaging_preview', meta: { title: i18n.t('packaging_preview') }},
                { path: '/package/stock/:id', component: PackageToStock, name: 'packaging_stock', meta: { title: i18n.t('packaging_stock') }},
                { path: '/change/password', component: ChangePassword, name: 'change_password', meta: { title: i18n.t('change_password') }},
                { path: '/positions', component: PositionList, meta: { title: i18n.t('job') }},
                { path: '/payrolls', component: Payroll, meta: { title: i18n.t('payroll') }},
                { path: '/preview/payroll/:id', component: PayrollPreview, name: 'payroll_preview', meta: { title: i18n.t('payroll') }},
                { path: '/allowances', component: Allowance, meta: { title: i18n.t('allowance') }},
                { path: '/employee/monthly/allowances', component: MonthlyAllowance, meta: { title: i18n.t('monthly_allowance') }},
                { path: '/discipline/list', component: DisciplineList, meta: { title: i18n.t('discipline') }},
                { path: '/discipline/create', component: DisciplineForm, meta: { title: i18n.t('discipline_create') }},
                { path: '/discipline/edit/:id', component: DisciplineForm, name: 'discipline_update', meta: { title: i18n.t('discipline_update') }},
                { path: '/user-profile', component: UserProfile, meta: { title: i18n.t('profile') }},
                { path: '/user-setting', component: UserSetting, meta: { title: i18n.t('setting') }},
            ]
        },
        {
            path: '/system/', component: SystemContainer,
            children: [
                { path: '/configuration', name: 'configuration', component: Systems.SystemConfiguration, meta: {title: i18n.t('configuration')}},
                { path: 'modules', component: Systems.SystemModuleList, meta: { title: i18n.t('modules') }},
                { path: 'sidebars', component: Systems.SystemSidebar, meta: { title: i18n.t('side_menus') }},
                { path: 'sidebar/:id', name: 'sidebar_update', component: Systems.SystemSidebarForm, meta: { title: i18n.t('sidebar_setup')}},
                { path: 'module', component: Systems.SystemModuleForm, meta: { title: i18n.t('module_create') }},
                { path: 'module/:id', name: 'module_update', component: Systems.SystemModuleForm, meta: { title: i18n.t('module_update') }},
                { path: 'menus', component: Systems.SystemMenuList, meta: { title: i18n.t('menus') }},
                { path: 'menu', component: Systems.SystemMenuForm, meta: { title: i18n.t('menus_create') }},
                { path: 'menu/:id', name: 'menu_update', component: Systems.SystemMenuForm, meta: { title: i18n.t('menus_update') }},
                { path: 'translate-language', component: Systems.TranslateLanguage, meta: { title: i18n.t('translate_language') }},
            ]
        },
        { path: '/login', name: 'login', component: Login, meta: { title: i18n.t('login') }}
    ]
});
router.beforeEach((to, from, next) => {
    if (excepts.includes(to.name)) {
        next();
    } else {
        if (localStorage.getItem('jwt') == null) {
            next('/login');
        } else {
            var expire = localStorage.getItem('jwt@exp');
            let now_time = moment().utc().format('YYYYMMDDHHmmss');
            if(expire == null || (expire != null && Number(expire) < Number(now_time))){
                next('/login');
            }else{
                next();
            }
            next();
        }
    }
    document.title = (to.meta.title != undefined?to.meta.title.toUpperCase():'');
    next();
});
export default router;
